import React from 'react';
import RiddleEmbed from './RiddleEmbed.js';

var RiddleEmbedBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    return /*#__PURE__*/React.createElement(RiddleEmbed, attrs);
  },
  metadata: {
    version: '1.0',
    name: 'constellation/riddle-embed',
    title: 'Riddle Embed',
    description: 'Embed a Riddle quiz in your content',
    icon: 'editor-help',
    keywords: ['media', 'iframes', 'quizes', 'embeds'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Media',
    attributes: {
      riddleId: {
        type: 'string',
        default: 'yzLxi8oj',
        label: 'Riddle ID',
        control: 'text'
      },
      initialHeight: {
        type: 'number',
        label: 'Initial Height',
        default: 400,
        control: 'number'
      },
      staticHeight: {
        type: 'boolean',
        label: 'Fixed Height',
        default: false,
        control: 'boolean'
      },
      lazyImages: {
        type: 'boolean',
        label: 'Lazy',
        default: true,
        control: 'boolean'
      }
    }
  }
};
var RiddleEmbedBlock$1 = RiddleEmbedBlock;

export { RiddleEmbedBlock$1 as default };
